export const RESOURCE_TYPES = {
    WIDGETS : 'Widgets',
    DASHBOARDS : 'Dashboards',
    APIS : 'APIs'
}


export const USER_ROLES = {
    SUPER_ADMIN : 'Super Administrator'
}


export const windlegendConfig = {
  title: 'kmph',
  showTitle: true,
  containerClass: 'wind-speed-legend',
  items: [
    { label: '<1',   color: '#3b2f8ab3', textColor: '#ffffff', tooltip: '<1 kmph - Calm' },
    { label: '1-6',  color: '#1f3fbfb3', textColor: '#ffffff', tooltip: '1-6 kmph - Light Air' },
    { label: '6-12', color: '#2563d4b3', textColor: '#ffffff', tooltip: '6-12 kmph - Light Breeze' },
    { label: '12-20',color: '#1a8fbeb3', textColor: '#ffffff', tooltip: '12-20 kmph - Gentle Breeze' },
    { label: '20-29',color: '#19b4a0b3', textColor: '#000000', tooltip: '20-29 kmph - Moderate Breeze' },
    { label: '29-39',color: '#22c9a0b3', textColor: '#000000', tooltip: '29-39 kmph - Fresh Breeze' },
    { label: '39-50',color: '#1fd48ab3', textColor: '#000000', tooltip: '39-50 kmph - Strong Breeze' },
    { label: '50-62',color: '#f5d020b3', textColor: '#000000', tooltip: '50-62 kmph - Near Gale' },
    { label: '62-75',color: '#f0900ab3', textColor: '#000000', tooltip: '62-75 kmph - Gale' },
    { label: '75-89',color: '#e84040b3', textColor: '#ffffff', tooltip: '75-89 kmph - Strong Gale' },
    { label: '89-103',color: '#c02020b3', textColor: '#ffffff', tooltip: '89-103 kmph - Storm' },
    { label: '103-117',color: '#8b1a1ab3', textColor: '#ffffff', tooltip: '103-117 kmph - Violent Storm' },
    { label: '>118',  color: '#5a0f0fb3', textColor: '#ffffff', tooltip: '>118 kmph - Hurricane Force' }
  ]
};



  export const lightninglegendConfig = {
    title: 'Flashes/100 Sq.km/5 mins',
    showTitle: true,
    // containerClass: 'wind-speed-legend',
    items: [
      { label: '0', color: '#ffffff', textColor: '#000000', tooltip: 'No' },
      { label: '0-20', color: '#fd0', textColor: '#000000', tooltip: 'Light' },
      { label: '20-60', color: '#eb3717ff', textColor: '#000000', tooltip: 'Moderate' },
      { label: '>60', color: '#ff0000', textColor: '#000000', tooltip: 'Severe' },]
      // { label: '29', color: '#60a5fa', textColor: '#000000', tooltip: '29-38 kmph - Moderate Breeze' },]
    };

    export const rainlegendConfig = {
      title: 'mm',
      showTitle: true,
      // containerClass: 'wind-speed-legend',
      items: [
        { label: '0-0.4', color: '#e6e6e6', textColor: '#000000', tooltip: 'No Rainfall' },
        { label: '0.4-2.6', color: '#ccffcc', textColor: '#000000', tooltip: 'Very Light Rain' },
        { label: '2.6-15.7', color: '#00cc44', textColor: '#000000', tooltip: 'Light Rain' },
        { label: '15.7-64.6', color: '#009933', textColor: '#000000', tooltip: ' Moderate Rainfall' },
        { label: '64.6-115.7', color: '#ffcccc', textColor: '#000000', tooltip: 'Heavy Rainfall' },
        { label: '115.7-204.6', color: '#ff3333', textColor: '#000000', tooltip: 'Very Heavy Rainfall' },
        { label: '>204.6', color: '#b30000', textColor: '#000000', tooltip: 'Extreme Heavy Rainfall' },]
        // { label: '29', color: '#60a5fa', textColor
    };
    export const floodwarninglegendConfig = {
      title: 'Flood Warning Levels',
      showTitle: true,
      // containerClass: 'wind-speed-legend',
      items: [
        { label: 'No Data', color: '#777171', textColor: '#000000', tooltip: 'No Warning' },
        { label: 'Normal Level', color: '#60a5fa', textColor: '#000000', tooltip: 'Advisory' },
        { label: 'Warning Level', color: '#ffa500', textColor: '#000000', tooltip: 'Watch' },
        { label: 'Danger Level', color: '#ff0000', textColor: '#000000', tooltip: 'Warning' },]
        // { label: '29', color: '#60a5fa', textColor
    };

    export const cyclonelegendConfig = {
      sections: [
        {
          title: 'Strike Probability %',
          showTitle: true,
          items: [
            { label: '90', color: '#5a00c8', textColor: '#ffffff', tooltip: '90% Strike Probability' },
            { label: '80', color: '#6e00ff', textColor: '#ffffff', tooltip: '80% Strike Probability' },
            { label: '70', color: '#c80000', textColor: '#ffffff', tooltip: '70% Strike Probability' },
            { label: '60', color: '#ff6600', textColor: '#000000', tooltip: '60% Strike Probability' },
            { label: '50', color: '#cc6600', textColor: '#000000', tooltip: '50% Strike Probability' },
            { label: '40', color: '#ffcc00', textColor: '#000000', tooltip: '40% Strike Probability' },
            { label: '30', color: '#ffff00', textColor: '#000000', tooltip: '30% Strike Probability' },
            { label: '20', color: '#ccff66', textColor: '#000000', tooltip: '20% Strike Probability' },
            { label: '10', color: '#66cc66', textColor: '#000000', tooltip: '10% Strike Probability' },
            { label: '5', color: '#009900', textColor: '#ffffff', tooltip: '5% Strike Probability' }
          ]
        },
        {
          title: 'Intensity',
          showTitle: true,
          items: [
            { label: 'L', color: '#cc00ff', textColor: '#ffffff', tooltip: 'Low Pressure' },
            { label: 'D', color: '#00ccff', textColor: '#000000', tooltip: 'Depression' },
            { label: 'DD', color: '#0099ff', textColor: '#ffffff', tooltip: 'Deep Depression' },
            { label: 'CS', color: '#0066cc', textColor: '#ffffff', tooltip: 'Cyclonic Storm' },
            { label: 'SCS', color: '#ffcc00', textColor: '#000000', tooltip: 'Severe Cyclonic Storm' },
            { label: 'VSCS', color: '#ff9900', textColor: '#000000', tooltip: 'Very Severe Cyclonic Storm' },
            { label: 'ESCS', color: '#ff0000', textColor: '#ffffff', tooltip: 'Extremely Severe Cyclonic Storm' },
            { label: 'SUCS', color: '#990000', textColor: '#ffffff', tooltip: 'Super Cyclonic Storm' }
          ]
        }
      ]
    };

    export const heatMapkeyword: Record<string, string> = {
  Normal: '#ffffff',
  normal: '#ffffff',
  caution: '#f5f5ba',
  Caution: '#f5f5ba',
  extreme_caution: '#ffcc66',
  'extreme caution': '#ffcc66',
  danger: '#ff6666',
  Danger: '#ff6666',
  extreme_danger: '#cc0000',
  'extreme danger': '#cc0000',
  Extreme_Danger: '#cc0000',
};

export function getHeatMapColor(alertType?: string): string {
  if (!alertType) {
    return heatMapkeyword['Normal'];
  }
  const normalized = alertType.trim().toLowerCase().replace(/\s+/g, '_');
  return (
    heatMapkeyword[alertType] ??
    heatMapkeyword[normalized] ??
    heatMapkeyword[alertType.trim()] ??
    '#999'
  );
}

// Cyclone intensity cEolor map
export const CYCLONE_COLOR_MAP: Record<string, string> = {
  L: '#cc00ff',    // Low Pressure
  D: '#00ccff',    // Depression
  DD: '#0099ff',   // Deep Depression
  CS: '#0066cc',   // Cyclonic Storm
  SCS: '#ffcc00',  // Severe Cyclonic Storm
  VSCS: '#ff9900', // Very Severe Cyclonic Storm
  ESCS: '#ff0000', // Extremely Severe Cyclonic Storm
  SUCS: '#990000'  // Super Cyclonic Storm
};

    export const heatmaplegendConfig = {
      title: 'Category',
      showTitle: true,
      // containerClass: 'wind-speed-legend',
      items: [
        { label: 'Normal', color: '#ffffff', textColor: '#000000', tooltip: '0-27' },
        { label: 'Caution', color: "#f5f5ba", textColor: '#000000', tooltip: '27-32' },
        { label: 'Extreme Caution', color: '#ffcc66', textColor: '#000000', tooltip: '32-41' },
        { label: 'Danger', color: '#ff6666', textColor: '#000000', tooltip: '41-54' },
        { label: 'Extreme Danger', color: '#cc0000', textColor: '#000000', tooltip: '>54' },]
        // { label: '29', color: '#60a5fa', textColor
    };

    export const heatmaplegendConfig1 = {
      title: 'Category',
      showTitle: true,
      // containerClass: 'wind-speed-legend',
      items: [
        { label: 'Normal', color: '#ffffff', textColor: '#000000'},
        { label: 'Heatwave', color: '#e7770eff', textColor: '#000000' },
        { label: 'Severe Heatwave', color: '#ec1414ff', textColor: '#000000' },]
        // { label: 'Danger', color: '#ff6666', textColor: '#ffffff', tooltip: '41-54' },
        // { label: 'Extreme Danger', color: '#cc0000', textColor: '#ffffff', tooltip: '>54' },]
        // { label: '29', color: '#60a5fa', textColor
      };

/** Index of "DEM Raster Layer" in the shared basemap gallery list. */
export const DEM_RASTER_BASEMAP_INDEX = 7;

export const demRasterLegendConfig = {
  title: 'DEM Raster Layer (Grey Index)',
  items: [
    { color: '#1a9850', label: '5.42 - 20' },
    { color: '#3cae51', label: '20 - 40' },
    { color: '#5fb85b', label: '40 - 60' },
    { color: '#82c266', label: '60 - 80' },
    { color: '#a6d96a', label: '80 - 100' },
    { color: '#c2e37e', label: '100 - 120' },
    { color: '#dfed93', label: '120 - 140' },
    { color: '#ffffbf', label: '140 - 160' },
    { color: '#ffe9a0', label: '160 - 180' },
    { color: '#fed283', label: '180 - 200' },
    { color: '#febb6b', label: '200 - 220' },
    { color: '#fca55a', label: '220 - 240' },
    { color: '#d73027', label: '240 - 259.80' },
  ]
};